import React, { useEffect } from 'react';
import { useOutlet } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import HomeDashboard from './HomeDashboard/HomeDashboard';
import TopNavBar from './TopNav'
import MobileTopNavBar from './MobileTopNav';
import Breadcrumbs from './Breadcrumbs';
import useIsMobileView from '../hooks/useIsMobileView';

export default () => {
  const isMobileView = useIsMobileView();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (pathname === '/') {
      navigate('home')
    }
  }, [pathname, navigate])

  const outlet = useOutlet()
  return (
    <>
      {
        isMobileView ?
        <MobileTopNavBar /> :
        <TopNavBar />
      }
      <Breadcrumbs />
      {outlet || <HomeDashboard />}
    </>
  )
}